import React, { useState } from 'react'

import SelectAsync from 'react-select/async'
import debounce from 'lodash.debounce'

import { LocationsApi, Location } from '@services/api/locations'

import { styles } from '../utils/select'

interface SelectLocationProps {
  value?: Location
  onChange?: (company: Location) => void
}

export const SelectLocation = ({
  value: location,
  onChange
}: SelectLocationProps) => {
  const [loading, setLoading] = useState(false)

  let valueInput = location
    ? { value: location, label: location.name }
    : undefined

  // selecionei uma cidade
  if (location?.state) {
    valueInput = {
      ...valueInput,
      label: `${location.state.uf} - ${location.name}`
    }
  }

  // selecionei um estado
  if (location?.uf) {
    valueInput = {
      ...valueInput,
      label: location?.uf
    }
  }

  const value = valueInput

  const search = debounce(
    async (value: string, callback: (value: any) => void) => {
      setLoading(true)
      try {
        const { data } = await LocationsApi.index({
          name: value
        })

        const formattedCityState = formatCityAndStateOptions(data)
        callback(formattedCityState)
      } catch (error) {
        console.error(error)
        callback(undefined)
      } finally {
        setLoading(false)
      }
    },
    500
  )

  const formatCityAndStateOptions = (data: Location[]) => {
    return data.map(location => {
      let label = location.name

      if (location?.state) {
        label = `${location.state.uf} - ${location.name}`
      }

      if (!location?.state) {
        label = `${location.uf}`
      }

      return {
        value: location,
        label
      }
    })
  }

  return (
    <SelectAsync
      instanceId="location"
      placeholder="Estado ou Cidade"
      className="react-select-container"
      classNamePrefix="react-select"
      noOptionsMessage={() => 'Digite Aqui'}
      styles={styles<Location>()}
      isClearable
      isSearchable
      loadOptions={search}
      isLoading={loading}
      value={value}
      onChange={option => onChange && onChange(option?.value)}
    />
  )
}
